import { Configuration, EnforcerApi, type ConfigurationParameters } from '@teemill/enforcer';
import type { App, MaybeRefOrGetter } from 'vue';

export let client: EnforcerApi;
export let project: MaybeRefOrGetter<string | undefined>;
export let user: MaybeRefOrGetter<string | undefined>;

export const authorize = {
  install(
    app: App,
    options: {
      client: ConfigurationParameters;
      project: MaybeRefOrGetter<string | undefined>;
      user: MaybeRefOrGetter<string | undefined>;
    },
  ) {
    client = new EnforcerApi(
      new Configuration({
        ...options.client,
        baseOptions: {
          headers: {
            'User-Agent': null,
          },
        },
      }),
    );
    project = options.project;
    user = options.user;
  },
};
